import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import { AccessControlType } from '@schemas'
import type {
	AuthStateType,
	CrudType,
	UserMenuAccessType,
	ApiGetDataStatus,
} from '@redux/types'

// initial state
const initialState: AuthStateType = {
	// trigger
	triggerInitLoginPage: false,
	triggerLogin: false,
	triggerCheckAccessToken: false,
	triggerAuthLoadingPage: false,

	// login
	isLogin: false,
	login: { email: '', password: '' },
	loginErrorMessage: '',
	checkPassword: '',
	checkPasswordStatus: 'init',
	isRememberId: false,

	// token
	token: { accessToken: '', refreshToken: '' },
	loginUsingAccessToken: { accessToken: '' },

	// access controls
	accessGroup: [],
	accessControls: [],
	userAccessMenuList: [],
	currentAccess: [],
}

const slice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_LOGIN_PAGE: (state: AuthStateType, action: PayloadAction<boolean>) => {
			state.triggerInitLoginPage = action.payload
		},
		TRIGGER_LOGOUT: (state: AuthStateType, action: PayloadAction<boolean>) => {
			state.triggerLogin = action.payload
		},
		TRIGGER_CHECK_ACCESS_TOKEN: (
			state: AuthStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerCheckAccessToken = action.payload
		},
		TRIGGER_AUTH_LOADING_PAGE: (state: AuthStateType, action: PayloadAction<boolean>) => {
			state.triggerAuthLoadingPage = action.payload
		},

		// login
		IS_LOGIN: (state: AuthStateType, action: PayloadAction<boolean>) => {
			state.isLogin = action.payload
		},
		LOGIN: (state: AuthStateType, action: PayloadAction<AuthStateType['login']>) => {
			state.login = action.payload
		},
		LOGIN_ERROR_MESSAGE: (
			state: AuthStateType,
			action: PayloadAction<AuthStateType['loginErrorMessage']>,
		) => {
			state.loginErrorMessage = action.payload
		},
		CHECK_PASSWORD: (state: AuthStateType, action: PayloadAction<string>) => {
			state.checkPassword = action.payload
		},
		CHECK_PASSWORD_STATUS: (
			state: AuthStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.checkPasswordStatus = action.payload
		},
		IS_REMEMBER_ID: (state: AuthStateType, action: PayloadAction<boolean>) => {
			state.isRememberId = action.payload
		},

		// token
		TOKEN: (state: AuthStateType, action: PayloadAction<AuthStateType['token']>) => {
			localStorage.setItem('accessToken', action.payload.accessToken)
			localStorage.setItem('refreshToken', action.payload.refreshToken)
			state.token = action.payload
		},
		LOGIN_USING_accessToken: (
			state: AuthStateType,
			action: PayloadAction<AuthStateType['loginUsingAccessToken']>,
		) => {
			state.loginUsingAccessToken = action.payload
		},

		// access controls
		ACCESS_GROUP: (state: AuthStateType, action: PayloadAction<string[]>) => {
			state.accessGroup = action.payload
		},
		ACCESS_CONTROLS: (
			state: AuthStateType,
			action: PayloadAction<AccessControlType[]>,
		) => {
			state.accessControls = action.payload
		},
		USER_ACCESS_MENU_LIST: (
			state: AuthStateType,
			action: PayloadAction<UserMenuAccessType[]>,
		) => {
			state.userAccessMenuList = action.payload
		},
		CURRENT_ACCESS: (state: AuthStateType, action: PayloadAction<CrudType>) => {
			state.currentAccess = action.payload
		},
	},

	extraReducers: builder => {
		builder.addCase(PURGE, () => initialState)
	},
})

export const authActions = slice.actions
export default slice.reducer
